"use client";

import { useEffect, useRef } from "react";

export default function EditableText({
  value,
  onChange,
  as = "span",
  className = "",
  style,
  multiline = false,
  placeholder,
}: {
  value: string;
  onChange: (value: string) => void;
  as?: "span" | "p" | "div" | "h1" | "li";
  className?: string;
  style?: React.CSSProperties;
  multiline?: boolean;
  placeholder?: string;
}) {
  const ref = useRef<HTMLElement | null>(null);
  const Tag = as as React.ElementType;
  const displayClass = as === "span" || as === "li" ? "inline-block" : "block";

  useEffect(() => {
    if (ref.current && ref.current.textContent !== value) {
      ref.current.textContent = value;
    }
  }, [value]);

  return (
    <Tag
      ref={ref}
      contentEditable
      suppressContentEditableWarning
      data-placeholder={placeholder}
      style={style}
      // Placeholder color inherits from whatever text color the caller's
      // className sets (text-current) at reduced opacity, instead of a
      // hardcoded gray — so it stays legible whether the surrounding text is
      // dark-on-light or light-on-dark (e.g. a sidebar with textOnDark).
      className={`${className} ${displayClass} min-w-[3ch] rounded outline-none empty:before:text-current empty:before:opacity-40 empty:before:content-[attr(data-placeholder)]`}
      onBlur={(e: React.FocusEvent<HTMLElement>) => onChange(e.currentTarget.textContent ?? "")}
      onKeyDown={(e: React.KeyboardEvent<HTMLElement>) => {
        if (!multiline && e.key === "Enter") {
          e.preventDefault();
          (e.currentTarget as HTMLElement).blur();
        }
      }}
    />
  );
}
